// @ts-nocheck

import { all, call, delay, put, takeLatest } from 'redux-saga/effects'
import { ContentActions, Course, Events, Banners } from './types'
import {
  ListEventResponse,
  listEventsService
} from '../../api/services/Events/listEvents'
import {
  listCoursesSuccessAction,
  listEventsSuccessAction,
  listBannersSuccessAction
} from './actions'
import { clearLoading, setLoading } from '../Loading/actions'
import { listCoursesService } from '../../api/services/courses/listCoursesService'
import { PayloadAction } from 'typesafe-actions'
import { filterEventService } from '../../api/services/Events/filterEventService'
import { listAllBannersService } from '../../api/services/listAllBannersService'

export function* listEventsRequest(
  action: PayloadAction<'', { state?: string; city?: string } | undefined>
) {
  try {
    const data: Events = yield call(listEventsService, action.payload)
    const banners: Banners = yield call(listAllBannersService)
    yield put(listBannersSuccessAction(banners))
    yield put(listEventsSuccessAction({ events: data }))
    // Safety: clear any stuck App overlay from auth/courses races
    yield put(clearLoading())
  } catch (e) {
    yield put({ type: ContentActions.listAllEventFailure })
    yield put(clearLoading())
  }
}

export function* listEventsRequestByCategory(
  action: PayloadAction<'', string>
) {
  try {
    yield put(setLoading())
    const data: ListEventResponse = yield call(filterEventService, {
      name: action.payload
    })
    yield put(listEventsSuccessAction({ events: data }))
    yield delay(1000)
    yield put(clearLoading())
  } catch (e) {
    yield put(clearLoading())
  }
}

export function* listCourses() {
  try {
    yield put(setLoading())
    const data: Course[] = yield call(listCoursesService)
    yield put(listCoursesSuccessAction(data))
  } catch (e) {
    // ignore
  } finally {
    yield put(clearLoading())
  }
}

export const ContentsSaga = all([
  takeLatest(ContentActions.listAllEventsRequest, listEventsRequest),
  takeLatest(ContentActions.listCoursesRequest, listCourses),
  takeLatest(
    ContentActions.filterEventsByCategoryRequest,
    listEventsRequestByCategory
  )
])
